import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=58a54bbc&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=58a54bbc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a54bbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a54bbc')) {
      api.createRecord('58a54bbc', component.options)
    } else {
      api.reload('58a54bbc', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=58a54bbc&scoped=true", function () {
      api.rerender('58a54bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/channel/online/Tripartite/DataForm.vue"
export default component.exports